import { render, staticRenderFns } from "./GrantTable.vue?vue&type=template&id=6dc44af0&scoped=true&"
import script from "./GrantTable.vue?vue&type=script&lang=js&"
export * from "./GrantTable.vue?vue&type=script&lang=js&"
import style0 from "./GrantTable.vue?vue&type=style&index=0&id=6dc44af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc44af0",
  null
  
)

export default component.exports